export default __webpack_public_path__ + "static/media/SairaExtraCondensed-Bold.68fc4616.ttf";